import React, { useContext, useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./Timeline.scss";
import MyContext from "../Context/MyContext";
import { format } from "date-fns";

const Timeline = () => {
  const { dailywork, fetchdaily, token, input, setInput, handleCommentdaily } =
    useContext(MyContext);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showModal, setShowModal] = useState(false);
  const [selectedWork, setSelectedWork] = useState(null);
  const [pendingApproval, setPendingApproval] = useState({});

  useEffect(() => {
    if (token) {
      fetchdaily();
    }
  }, [token]);

  // Format date to match backend format
  const formatToBackendDate = (date) => {
    return format(date, "yyyy-MM-dd");
  };

  // Check if date has work assigned
  const hasWork = (date) => {
    return dailywork.some((work) => work.date === formatToBackendDate(date));
  };

  // Get work for specific date
  const getWorkForDate = (date) => {
    return dailywork.filter((work) => work.date === formatToBackendDate(date));
  };

  // Check if date is a holiday (Thursday, Saturday, Sunday)
  const isHoliday = (date) => {
    const day = date.getDay(); // 0 = Sunday, 4 = Thursday, 6 = Saturday
    return day === 0 || day === 3 || day === 6;
  };

  // Calendar tile content
  const tileContent = ({ date, view }) => {
    if (view !== "month") return null;

    if (isHoliday(date)) {
      return (
        <div className="holiday-marker">
          <div className="holiday-tooltip">Holiday</div>
        </div>
      );
    }

    return hasWork(date) ? (
      <div className="task-marker">
        <div className="task-tooltip">Work Assigned</div>
      </div>
    ) : null;
  };

  // Handle date click - prevent clicking on holidays
  const handleDateClick = (date) => {
    if (isHoliday(date)) return;

    if (hasWork(date)) {
      const workItems = getWorkForDate(date);
      setSelectedWork(workItems);
      setShowModal(true);
    }
  };

  // Custom tile class for holidays
  const tileClassName = ({ date, view }) => {
    if (view !== "month") return null;
    return isHoliday(date) ? "holiday" : null;
  };

  // Handle comment submission
  const handleCommentSubmit = (workId) => {
    handleCommentdaily(workId);
    setPendingApproval((prev) => ({ ...prev, [workId]: true }));
  };

  return (
    <div className="timeline-container">
      <div className="calendar-wrapper">
        <Calendar
          onChange={setSelectedDate}
          value={selectedDate}
          tileContent={tileContent}
          tileClassName={tileClassName}
          onClickDay={handleDateClick}
          className="internship-calendar"
          minDetail="month"
          prev2Label={null}
          next2Label={null}
        />
      </div>

      {/* Work Details Modal */}
      {showModal && selectedWork && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Work for {format(selectedDate, "dd/MM/yyyy")}</h2>
            <button className="close-modal" onClick={() => setShowModal(false)}>
              ×
            </button>

            {selectedWork.map((work) => (
              <div key={work._id} className="work-item">
                <div className="work-description">
                  <h3>Assigned Work:</h3>
                  <pre>{work.work}</pre>
                </div>

                <div className="comment-section">
                  <h3>Your Comments:</h3>
                  {work.comment ? (
                    <div className="existing-comment">
                      <p>{work.comment}</p>
                      {pendingApproval[work._id] && (
                        <span className="pending-badge">Pending Approval</span>
                      )}
                    </div>
                  ) : (
                    <>
                      <textarea
                        placeholder="Add your comments here..."
                        value={input[work._id] || ""}
                        onChange={(e) =>
                          setInput((prev) => ({
                            ...prev,
                            [work._id]: e.target.value,
                          }))
                        }
                      />
                      <button
                        onClick={() => handleCommentSubmit(work._id)}
                        disabled={pendingApproval[work._id]}
                      >
                        {pendingApproval[work._id]
                          ? "Submitting..."
                          : "Submit Comment"}
                      </button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Timeline;
